import { render, staticRenderFns } from "./RoomOrder.vue?vue&type=template&id=21205c35&"
import script from "./RoomOrder.vue?vue&type=script&lang=js&"
export * from "./RoomOrder.vue?vue&type=script&lang=js&"
import style0 from "./RoomOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports